/**
 * Kääntää annetun arvon oikealle kielelle. Jos käännös on {@link ITranslatableString}in sijasta string, palautetaan se.
 * Jos {@link ITranslatableString}istä ei löydy halutulle kielelle käännöstä, fallbackataan kielelle **fi**.
 * @param translatable käännettävä teksti
 * @param language kieli, jolle teksti halutaan kääntää
 * @return käännetyn version tai tyhjän stringin, jos käännöstä ei löydy.
 */
var translationHelper = function translationHelper(translatable, language) {
  if (translatable === null || translatable === undefined) {
    return "";
  }

  if (typeof translatable === "string") {
    return translatable;
  }

  if (typeof translatable === "object") {
    translatable = translatable;

    if (translatable[language]) {
      return translatable[language];
    }

    return translatable["fi"];
  }

  return "";
};

var classNames = function classNames() {
  var classes = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    classes[_i] = arguments[_i];
  }

  return classes.filter(Boolean).join(' ');
};
/**
 * Poistaa HTML-tägit annetusta stringistä
 * @param text muokattava teksti
 */


var stripHtmlFromStringHelper = function stripHtmlFromStringHelper(text) {
  return text.replace(/(<([^>]+)>)/gi, "");
};

export { classNames, stripHtmlFromStringHelper as stripHtmlFromString, translationHelper };